import {ValgtSakRegister} from "web-ng2/tjenester/ValgtSakRegister";

/**
 * Navn som ng2-tjenester som skal kunne brukes i ajs-kode er registrert under.
 * Tjenestene er definert i nedgraderteNg2Tjenester.ts
 */
export const ng2RegNavn = {
    MøteDatatjenesteForAjs: 'MøteDatatjenesteForAjs',
    GruppeDatatjenesteForAjs: 'GruppeDatatjenesteForAjs',
    GruppemedlemDatatjenesteForAjs: 'GruppemedlemDatatjenesteForAjs',
    KommentarDatatjenesteForAjs: 'KommentarDatatjenesteForAjs',
    SakDatatjenesteForAjs: 'SakDatatjenesteForAjs',
    SakstidspunkterForAjs: 'SakstidspunkterForAjs',
    ValgtSakRegisterForAjs: 'ValgtSakRegisterForAjs',
    SaksdokumentDatatjenesteForAjs: 'SaksdokumentDatatjenesteForAjs',
    OppgaveDatatjenesteForAjs: 'OppgaveDatatjenesteForAjs',
    BeslutningDatatjenesteForAjs: 'BeslutningDatatjenesteForAjs',
    MøtedialogerForAjs: 'MøtedialogerForAjs',
    Ng2DialogTjenesterForAjs: 'Ng2DialogTjenesterForAjs',
    CdkScrollableSomTjenesteForAjs: 'CdkScrollableSomTjenesteForAjs',
    NgZoneForAjs: 'NgZoneForAjs',
    PresentasjonsmodusTjenesteForAjs: 'PresentasjonsmodusTjenesteForAjs'
}

